import CardUI from "@UI/CardUI";

import { inject, observer } from "mobx-react";
import { computed } from "mobx";

import "./style.scss";

const MainBlock = inject("mainStore")(
    observer(({ mainStore, auth }) => {
        const offers = computed(() => mainStore.getMainStore("suggest.vendors_suggest")).get();
        const partners = computed(() => mainStore.getMainStore("suggest.offers_suggest")).get();

        const offers_count = partners ? partners.filter((i) => i.active) : 0;

        const data = [
            { title: "Вендора", count: offers.length, icon: "pi-users" },
            { title: "Офферы", count: offers_count.length, icon: "pi-ticket" },
        ];

        return (
            <CardUI title={`Привет, ${auth.firstName}!`} className="main-block">
                <div className="main-block__content">
                    {data.map((item, idx) => (
                        <div className="card" key={idx}>
                            <div className="card__header">
                                <span>{item.title}</span>
                                <i className={`pi ${item.icon}`} style={{ fontSize: "1.5rem" }}></i>
                            </div>
                            <span className="card__count">{item.count}</span>
                            {/* <span className='card__new-count'>{`+${item.newCount} новых за последнюю неделю `}</span> */}
                        </div>
                    ))}
                </div>
            </CardUI>
        );
    }),
);
export default MainBlock;
